const styles = theme => ({
  root: {
    padding: '12px 18px 12px 18px',
    backgroundColor: '#eeeeee'
  }
});

export default styles;
